import { Divider, Grid, styled } from '@mui/material';

export const ProductImgContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.brand.whitesmoke,
  border: `1px solid ${theme.palette.brand.disable}`,
  borderRadius: '4px',
  overflow: 'hidden',
  width: '100%',
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    userDrag: 'none',
  },
}));

export const ProductDivider = styled(Divider)(() => ({
  margin: '24px 0',
}));

export const RadioContainer = styled(Grid)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.brand.disable}`,
  padding: '8px 16px',
  '&:last-child': {
    marginBottom: '16px',
  },
}));
